import { useEffect, useState } from 'react';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../../utils/displayNudosStandardNotifications';
import { NudosSelectButton } from '../../../../../../components/NudosComponents';
import { updateOrganizationType } from '../../../../../../services/bussines';
import { CLIENT_TYPES, TClientType } from '../../../../../../types/client.types';
import useOrganizationState from 'state/useOrganizationState';

const ClientType = ({
  organizationId,
  updateWithoutLoaders
}: {
  organizationId: string;
  updateWithoutLoaders?: () => Promise<void>;
}) => {
  const { organizationData, generalLoader } = useOrganizationState();
  const [clientType, setClientType] = useState<TClientType>(CLIENT_TYPES.CLIENT);
  const [isChangingClientTypeLoading, setIsChangingClientTypeLoading] = useState<boolean>(false);

  const loadingClientType = generalLoader || isChangingClientTypeLoading;

  const assignClientType = () => {
    if (!organizationData) return;
    const { organizationType } = organizationData;
    const { id: organizationTypeId } = organizationType;
    setClientType(organizationTypeId as TClientType);
  };

  const handleUpdateClientType = async (type: TClientType) => {
    setIsChangingClientTypeLoading(true);
    try {
      await updateOrganizationType(+organizationId, { organizationTypeId: type });
      setClientType(type);
      await updateWithoutLoaders?.();
      setIsChangingClientTypeLoading(false);
      displaySuccessNotification({ customJSXMessage: <>Se actualizó el tipo de facturación correctamente</> });
    } catch (error) {
      displayErrorNotification();
    } finally {
      setIsChangingClientTypeLoading(false);
    }
  };

  useEffect(() => {
    assignClientType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="accountTitle">Tipo de facturación</div>
      <div className="accountOptions">
        {loadingClientType ? (
          <div className="loaderOptions animationLoader" />
        ) : (
          <>
            <div className="optionAccount">
              <NudosSelectButton
                colorPalette="black"
                handleClickButton={() => handleUpdateClientType(CLIENT_TYPES.CLIENT)}
                isButtonActive={clientType === CLIENT_TYPES.CLIENT}
              />
              <div className="optionText">Reglas estándar</div>
            </div>
            <div className="optionAccount">
              <NudosSelectButton
                colorPalette="black"
                handleClickButton={() => handleUpdateClientType(CLIENT_TYPES.PARTNER)}
                isButtonActive={clientType === CLIENT_TYPES.PARTNER}
              />
              <div className="optionText">Facturación centralizada desde Uruguay</div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ClientType;
